import { makeVar } from '@apollo/client';

export const storeConfigVar = makeVar({});
export const storeLogoVar = makeVar({});

export default {
    storeConfigVar,
    storeLogoVar,
};
